export const newRelicViewSample = {
    'severity': 'CRITICAL',
    'policy_name': 'Cpu_Metrics',
    'targets': [
        {
            'name': 'SEOUL-A-DEV-LIGHTSABER-EXTENSION-DAEMON01 (eth0)',
            'product': 'INFRASTRUCTURE',
            'type': 'Host'
        }
    ],
    'event_type': 'INCIDENT',
    'account_name': 'bespinglobal_6',
    'details': 'Test_Cpu_Metrics: Critical on SEOUL-A-DEV-LIGHTSABER-EXTENSION-DAEMON01 (eth0)',
    'condition_name': 'Test_Cpu_Metrics'
};

export const newRelicSample = {
    'severity': 'CRITICAL',
    'policy_name': 'Cpu_Metrics',
    'targets[].name': '[SEOUL-A-DEV-LIGHTSABER-EXTENSION-DAEMON01 (eth0)]',
    'targets[].product': '[INFRASTRUCTURE]',
    'targets[].type': '[Host]',
    'event_type': 'INCIDENT',
    'account_name': 'bespinglobal_6',
    'details': 'Test_Cpu_Metrics: Critical on SEOUL-A-DEV-LIGHTSABER-EXTENSION-DAEMON01 (eth0)',
    'condition_name': 'Test_Cpu_Metrics'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/newRelic.ts